export default __webpack_public_path__ + "static/media/bg_battle.f58c3f1a.webp";